import { render, staticRenderFns } from "./interactionBox.vue?vue&type=template&id=737d6843&scoped=true&"
import script from "./interactionBox.vue?vue&type=script&lang=js&"
export * from "./interactionBox.vue?vue&type=script&lang=js&"
import style0 from "./interactionBox.vue?vue&type=style&index=0&id=737d6843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d6843",
  null
  
)

export default component.exports